import { render } from "./AlarmasView.vue?vue&type=template&id=93547f20&scoped=true"
import script from "./AlarmasView.vue?vue&type=script&lang=js"
export * from "./AlarmasView.vue?vue&type=script&lang=js"

import "./AlarmasView.vue?vue&type=style&index=0&id=93547f20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93547f20"]])

export default __exports__